import { Deserializable } from '../interfaces';

export class SocialNetworks implements Deserializable {
  idRedSocial: number;
  idRedTarjeta: number;
  idTarjeta: number;
  urlRedSocial: string;
  redSocial: string;
  idUsuario: number;
  idioma: string;

  constructor() {
    this.idRedSocial = 0;
    this.idRedTarjeta = 0;
    this.idTarjeta = 0;
    this.urlRedSocial = '';
    this.redSocial = '';
    this.idUsuario = 0;
    this.idioma = 'esp';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
